// IMPORT
const THREE = require('three')
import Runner from './runner'
import {loadingManager, load, registerSize} from '../loader'
import {config as gameConfig} from '../config'
import {state as gameState} from '../main'
import {TimelineMax, TweenMax, Cubic, Expo, CustomEase, SlowMo, Linear} from 'gsap'
import lerp from 'lerp'

// ****************************************************************
//
// CLASS
//
// ****************************************************************
class Vehicle extends Runner {

  constructor (config) {
    let state = Object.assign(config, {autoUpdateState: false})
    super(state)
    this.initialState = Object.assign({}, state)

    this.model = new THREE.Object3D()

    this.mesh.add(this.model)
    this.init()
  }

  // **********************************************************************
  //
  // INIT
  //
  // **********************************************************************
  initModel () {

    for (let part of this.state.parts) {
      let url = part.model.url
      let size = part.model.size
      registerSize(url, size)
      load(url, new THREE.JSONLoader(loadingManager), (results)=> {

        // GEOMETRY
        // let geometry = results[0].geometries[0] // JD
        part.geometry = results[0] // JSON
        part.geometry.computeFaceNormals()
        part.geometry.computeVertexNormals()

        // MATERIAL
        part.material = new THREE.MeshBasicMaterial({
          transparent: false,
          map: part.map
        })

        // MESH
        part.model = new THREE.Mesh(part.geometry, part.material)
        part.model.scale.setScalar(part.scale * gameConfig.worldScale)
        part.model.position.set(part.x || 0, part.y || 0, part.z || 0)
        part.model.castShadow = true
        this.model.add(part.model)

      })
    }
  }

  initTexture () {
    for (let part of this.state.parts) {
      let url = part.texture.url
      let size = part.texture.size
      registerSize(url, size)
      load(url, new THREE.TextureLoader(loadingManager), (results)=> {
        part.map = results[0]
        if (part.material) {
          part.material.map = part.map
          part.material.needsUpdate = true
        }
      })
    }
  }

  initAudio () {
    for (let key in this.state.sounds) {
      let sound = this.state.sounds[key]
      registerSize(sound.url, sound.size)
      load(sound.url, null, (results)=> {
        // this.audio[key].buffer = results[0]
        this.audio[key].setBuffer(results[0])
        this.audio[key].setRolloffFactor(10)
        // this.audio[key].setDistanceModel('exponential')
        this.audio[key].setLoop(true)
        this.audio[key].setDistanceModel('inverse')
      })
    }
  }


  // **********************************************************************
  //
  // UPDATE
  //
  // **********************************************************************


  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  toUser = (offset = -0.5)=> {
    this.state.distance = this.state.distanceStart + gameState.progress.percent + offset
  }

  toUserFront = (time = 1, startOffset = -0.01, endOffset = 0.012)=> {
    if (this.tween) this.tween.kill()

    let startDistance = this.state.distanceStart + gameState.progress.percent + startOffset

    this.state.distance = startDistance
    this.tween = TweenMax.to({val: 0}, time, {
      val: 1,
      ease: Expo.easeOut,
      onUpdateParams: ['{self}'],
      onUpdate: (tween)=> {
        let endDistance = this.state.distanceStart + gameState.progress.percent + endOffset
        this.state.distance = lerp(startDistance, endDistance, tween.target.val)
      }
    })
  }

  catchUpAndPass = (time = 1.6, delay = 2, percentInfront = 0.003, maxVel = 300, multiplier = 1.02)=> {
    let startDistance = this.state.distanceStart + gameState.progress.percent - 0.005
    this.state.distance = startDistance

    this.state.distance = startDistance
    let tl = new TimelineMax()

    let rotStart = new THREE.Vector3(0, THREE.Math.DEG2RAD * 180, 0)
    let posStart = this.model.position


    tl
      .addLabel('start')
      .to({val: 0}, time, {
        val: 1,
        // ease: Cubic.easeOut,
        ease: Linear.easeNone,
        onUpdateParams: ['{self}'],
        onUpdate: (tween)=> {
          let endDistance = this.state.distanceStart + gameState.progress.percent + percentInfront
          this.state.distance = lerp(startDistance, endDistance, tween.target.val)
        },
        onComplete: ()=> {
          this.state.px = (gameState.progress.percent + percentInfront) * gameConfig.totalPx
          this.state.maxVel = maxVel
          this.state.autoUpdateState = true
        }
      })
      // .to(this.model.rotation, time, {
      //   x: rotStart.x + THREE.Math.DEG2RAD * -50,
      //   ease: Cubic.easeOut
      // }, 'start')

      .addLabel('end')
      .to(this.state, time, {
        delay: 2,
        multiplyVelocity: multiplier,
        ease: Cubic.easeIn
      }, 'end')

  }

  stop = (distance)=> {
    // this.state = Object.assign({}, this.initialState)
  }

  runToEnd = (fromDistance, time = 7, ease = SlowMo.ease.config(0.5, 0.8))=> {
    let toDistance = 2.1
    this.state.px = fromDistance * gameConfig.totalPx
    this.state.distance = fromDistance
    this.state.autoUpdateState = false

    // let last = fromDistance
    TweenMax.to(this.state, time, {
      distance: toDistance,
      ease: ease
      // onUpdateParams: ['{self}'],
      // onUpdate: (tween)=> {
      //   if (tween.target.distance < last) console.log(last, tween.target.distance)
      //   last = tween.target.distance
      //   // if (this.state.type === 'car')
      //   // this.state.px = (tween.target.distance - this.state.distanceStart) * gameConfig.totalPx
      // }
    })
  }

  fadeTo = (opacity, time = 1)=> {
    return new Promise((resolve)=> {
      TweenMax.to({opacity: this.state.parts[0].material.opacity}, time, {
        opacity: opacity,
        ease: Cubic.easeOut,
        onUpdateParams: ['{self}'],
        onUpdate: (tween)=> {
          for (let part of this.state.parts) {
            part.material.opacity = tween.target.opacity
            part.material.needsUpdate = true
          }
        },
        onComplete: resolve
      })
    })
  }

}


export default Vehicle



// WEBPACK FOOTER //
// ./src/components/game/runner/vehicle.js